import PropTypes from 'prop-types'
import { Controller, useFormContext } from 'react-hook-form'
import { InputTags } from 'react-bootstrap-tagsinput'
import 'react-bootstrap-tagsinput/dist/index.css'
import { FormGroupContainer, FormLabelStyled, FormTextStyled } from '../styled'

export default function FormInputTags({ name, label, helperText, ...rest }) {
  const { control } = useFormContext()
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormGroupContainer>
          <FormLabelStyled>{label}</FormLabelStyled>
          <InputTags
            className={fieldState.error ? 'form-control is-invalid' : ''}
            onTags={(value) => {
              const event = { target: { value: value.values } }
              return field.onChange(event)
            }}
            values={field.value}
            style={{
              borderRadius: '6px',
              fontSize: '12px',
              minHeight: '36px',
            }}
            {...rest}
          />
          <FormTextStyled isError={!!fieldState.error}>
            {fieldState.error ? fieldState.error.message : helperText}
          </FormTextStyled>
        </FormGroupContainer>
      )}
    />
  )
}

FormInputTags.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
}

FormInputTags.defaultProps = {
  helperText: '',
}
